import FormattedMessage from 'I18n/components/FormattedMessage';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { getTypeAction, UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { jsx as _jsx } from "react/jsx-runtime";
function PendingApprovalButtonI18nHeadingNonParticipant() {
  const approval = useApprovalContext();
  const {
    approvalType,
    approvalAction
  } = approval.meta;
  const typeAction = getTypeAction(approvalType, approvalAction);
  switch (typeAction) {
    case 'MARKETING_EMAIL-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipHeadingText.NON_PARTICIPANT.MARKETING_EMAIL-PUBLISH"
        });
      }
    case 'LANDING_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipHeadingText.NON_PARTICIPANT.LANDING_PAGE-PUBLISH"
        });
      }
    case 'SITE_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipHeadingText.NON_PARTICIPANT.SITE_PAGE-PUBLISH"
        });
      }
    case 'BLOG_POST-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipHeadingText.NON_PARTICIPANT.BLOG_POST-PUBLISH"
        });
      }
    case 'DEAL-MOVE_STAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipHeadingText.NON_PARTICIPANT.DEAL-MOVE_STAGE"
        });
      }
    case 'KNOWLEDGE_ARTICLE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipHeadingText.NON_PARTICIPANT.KNOWLEDGE_ARTICLE-PUBLISH"
        });
      }
    default:
      throw new UnreachableI18nCaseError(typeAction);
  }
}
export default PendingApprovalButtonI18nHeadingNonParticipant;